import React from 'react';
import { Clock } from 'lucide-react';
import { fallbackContent } from '../hooks/useContent';

const Electronics = ({ data = fallbackContent.electronics }) => {
  const products = data.products || [];
  return (
    <section id="electronics" className="py-20 lg:py-28 bg-[#0d1e33] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#c9a227]/15 border border-[#c9a227]/30 mb-4">
            <Clock size={14} className="text-[#c9a227]" />
            <span className="section-label text-[#c9a227]">Coming Soon</span>
          </span>
          <h2 className="font-display font-bold text-4xl lg:text-5xl">{data.heading}</h2>
          <p className="mt-4 text-white/60">{data.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 gap-5">
          {products.map((p, i) => (
            <div key={i} className="group relative rounded-2xl overflow-hidden border border-white/10 bg-white/5">
              <div className="aspect-[4/3] overflow-hidden bg-[#12263f]">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1e33] via-[#0d1e33]/30 to-transparent" />
              </div>

              {/* Coming soon ribbon */}
              <div className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-[#c9a227] text-[#12263f] text-[10px] font-bold tracking-wide uppercase">
                Coming Soon
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-display font-bold text-lg">{p.name}</h3>
                <p className="text-xs text-white/50 mt-0.5">Launching soon</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Electronics;
